import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `AlbaranManual/addAlbaran`, method: 'POST', body: values, token: token})
}
